import { t } from 'i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Contact = () => {
  const contactInfo = [
    {
      icon: faEnvelope,
      delay: "0.3s",
      items: ["info@alrawabit.com.ly"]
    },
    {
      icon: faPhoneAlt,
      delay: "0.4s",
      items: ["+218 91 3804049"]
    },
    {
      icon: faWhatsapp,
      delay: "0.4s",
      items: ["+218 91 0200600"]
    },
  ];

  return (
    <div className="container-xxl contact py-5">
      <div className="container">
        <div className="section-title text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '500px' }}>
          <p className="fs-5 fw-medium fst-italic text-primary">{t('contact_us')}</p>
          <h1 className="display-6">{t('contact_now')}</h1>
        </div>
        <div className="row justify-content-center wow fadeInUp" data-wow-delay="0.1s">
          <div className="col-lg-8">
            <p className="text-center mb-5">{t('contact_ready')}</p>
            <div className="row g-5">
              {contactInfo.map((info, index) => (
                <div key={index} className="col-md-4 text-center wow fadeInUp" data-wow-delay={info.delay}>
                  <div className="btn-square mx-auto mb-3">
                    <FontAwesomeIcon icon={info.icon} className='fa-2x text-white' />
                  </div>
                  {info.items.map((item, itemIndex) => (
                    <p key={itemIndex} className={itemIndex === 0 ? "mb-2 p-ltr" : "mb-0 p-ltr"}>{item}</p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;